import { Container, Carousel, Image } from 'react-bootstrap'

const TakeAPeek = () => (
    <>
    <div className="section-take-a-peek">
        <Container>
            <h2 className="text-center text-white">Take a peek at what's inside</h2>
            <Carousel interval={null}>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 1" src="../images/7bs/img-slider-slide01.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 2" src="../images/7bs/img-slider-slide02.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 3" src="../images/7bs/img-slider-slide03.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 4" src="../images/7bs/img-slider-slide04.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 5" src="../images/7bs/img-slider-slide05.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 6" src="../images/7bs/img-slider-slide06.png" className="w-100"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Big Secrets To Losing Weight 7" src="../images/7bs/img-slider-slide07.png" className="w-100"/>
                </Carousel.Item>
            </Carousel>
        </Container>
    </div>
    <style jsx global>{`

            .section-take-a-peek {
                background: #de7621;
            }

            .section-take-a-peek .container {
                padding-top: 60px;
                padding-bottom: 140px;
            }

            .section-take-a-peek h2 {
                text-transform: uppercase;
                font-weight: 700;
                font-size: 40px;
                margin-bottom: 45px;
            }

            .section-take-a-peek .carousel {
                max-width: 600px;
                margin: 0px auto;
            }

            .section-take-a-peek .carousel .carousel-indicators {
                bottom: -60px;
            }

            .section-take-a-peek .carousel .carousel-indicators li {
                width: 16px;
                height: 16px;
                background: #000;
                border: none;
                margin: 0px 4px;
                border-radius: 10px;
            }

            .section-take-a-peek .carousel .carousel-indicators .active {
                background: #fff;
            }

            .section-take-a-peek .carousel .carousel-control-prev,
            .section-take-a-peek .carousel .carousel-control-next {
                background: none;
                font-size: 34px;
                color: #00aec7;
                opacity: 1;
                text-shadow: none;
            }

            .section-take-a-peek .carousel .carousel-control span {
                position: absolute;
                top: 50%;
            }

            .section-take-a-peek .carousel .carousel-control-prev {
                left: -95px;
                color: #00aec7;
            }

            .section-take-a-peek .carousel .carousel-control-prev span {
                background: url(../images/7bs/img-prev01.png) no-repeat center center;
                height: 50px;
                width: 50px;
            }

            .section-take-a-peek .carousel .carousel-control-next {
                right: -100px;
            }

            .section-take-a-peek .carousel .carousel-control-next span {
                background: url(../images/7bs/img-next01.png) no-repeat center center;
                height: 50px;
                width: 50px;
            }

            @media (max-width: 767.98px) {	

                .section-take-a-peek .container {
                    padding-top: 40px;
                    padding-bottom: 100px;
                }

                .section-take-a-peek h2 {
                    font-size: 34px;
                    margin-bottom: 25px;
                }

                .section-take-a-peek .carousel .carousel-indicators {
                    bottom: -70px;
                }

                .section-take-a-peek .carousel .carousel-control-prev {
                    left: 0px;
                }

                .section-take-a-peek .carousel .carousel-control-next {
                    right: 0px;
                }

            }

        `}</style>
    </>
);

export default TakeAPeek;